module.exports = __webpack_public_path__ + "img/swiper.1d39aa91.png";